/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { HiOutlineDocument } from "react-icons/hi";
import { VscFileSubmodule } from "react-icons/vsc";
import { BsBook, BsPeople } from "react-icons/bs";
import { GrAttraction, GrRestaurant } from "react-icons/gr";
import {
  MdShop,
  MdMusicNote,
  MdOutlineMuseum,
  MdOutlineNightlight,
  MdOutlineHotelClass,
  MdOutlineFoodBank,
  MdOutlineFormatPaint,
  MdOutlineMapsHomeWork,
} from "react-icons/md";
import { SiHotelsdotcom } from "react-icons/si";
import { AiOutlineShopping } from "react-icons/ai";
import { BiCameraMovie } from "react-icons/bi";
import { GiTheater, GiBallerinaShoes } from "react-icons/gi";

import { Card } from "../../component/Component";
import { useDashboardContext } from "../../../../context/dashboard/context/DashboardContext";
import { TableStatistics } from "../dashboard/DashBoard";
import { pushLevel } from "../../../../middlewares";
import { addOneLevel } from "../../../../middlewares/breadCrumb/BreadCrumb";
import { useAdminContext } from "../../../../context/admin/context/AdminContext";
import { getType } from "../contentStats/helper";
import { _TYPES_ } from "../../../doseeData/utils/types";

const Content = () => {
  const { sysAdmin, setSingleAdmin } = useAdminContext();
  const { stats, fetchData } = useDashboardContext();

  // UI-only polish
  const [query, setQuery] = useState("");
  const [category, setCategory] = useState("All"); // All | Geography | Content

  useEffect(() => {
    if (!stats) fetchData();
  }, [stats]);

  // Source of truth (unchanged)
  const List = [
    { name: "regions", quantity: stats ? stats?.continent_region : "-", route: "/region/manage" },
    { name: "countries", quantity: stats ? stats?.country : "-", route: "/countries" },
    { name: "First Level", quantity: stats ? stats?.first_level : "-", route: "/levels/first" },
    { name: "Second Level", quantity: stats ? stats?.second_level : "-", route: "/levels/second" },
    { name: "Third Level", quantity: stats ? stats?.third_level : "-", route: "/levels/third" },
    { name: "Fourth Level", quantity: stats ? stats?.fourth_level : "-", route: "/levels/fourth" },

    { name: "events", quantity: stats ? stats?.event : "-", route: "/data/event", key: _TYPES_.EVENT },
    { name: "attractions", quantity: stats ? stats?.attraction : "-", route: "/data/attraction", key: _TYPES_.ATTRACTION },
    { name: "restaurants", quantity: stats ? stats?.restaurant : "-", route: "/data/restaurant", key: _TYPES_.RESTAURANT },
    { name: "best of africa", quantity: stats ? stats?.best_of_africa : "-", route: "/data/bestofafrica", key: _TYPES_.BESTOFAFRICA },
    { name: "music", quantity: stats ? stats?.music : "-", route: "/data/music", key: _TYPES_.MUSIC },
    { name: "news", quantity: stats ? stats?.news : "-", route: "/data/news", key: _TYPES_.NEWS },
    { name: "safaris", quantity: stats ? stats?.safari : "-", route: "/data/safari", key: _TYPES_.SAFARI },
    { name: "tour packages", quantity: stats ? stats?.tour_package : "-", route: "/data/tour/package", key: _TYPES_.TOURPACKAGE },
    { name: "cinema", quantity: stats ? stats?.cinema : "-", route: "/data/cinema", key: _TYPES_.CINEMA },
    { name: "museums", quantity: stats ? stats?.museum : "-", route: "/data/museum", key: _TYPES_.MUSEUM },
    { name: "night life", quantity: stats ? stats?.nightlife : "-", route: "/data/nightlife", key: _TYPES_.NIGHTLIFE },
    { name: "hotels", quantity: stats ? stats?.hotel : "-", route: "/data/hotel", key: _TYPES_.HOTEL },
    { name: "classes", quantity: stats ? stats?.class : "-", route: "/data/class", key: _TYPES_.CLASSES },
    { name: "shopping", quantity: stats ? stats?.shopping : "-", route: "/data/shopping", key: _TYPES_.SHOPPING },
    { name: "food", quantity: stats ? stats?.food : "-", route: "/data/food", key: _TYPES_.FOOD },
    { name: "books", quantity: stats ? stats?.book : "-", route: "/data/book", key: _TYPES_.BOOK },
    { name: "neighborhoods", quantity: stats ? stats?.neighborhood : "-", route: "/data/neighborhood", key: _TYPES_.NEIGHBORHOOD },
    { name: "arts", quantity: stats ? stats?.art : "-", route: "/data/art", key: _TYPES_.ART },
    { name: "dance", quantity: stats ? stats?.dance : "-", route: "/data/dance", key: _TYPES_.DANCE },
    { name: "theaters", quantity: stats ? stats?.theater : "-", route: "/data/theater", key: _TYPES_.THEATER },
    { name: "City Guides", quantity: stats ? stats?.city_guide : "-", route: "/data/city/guide", key: _TYPES_.CITYGUIDE },
    { name: "Parties", quantity: stats ? stats?.party : "-", route: "/data/party", key: _TYPES_.PARTY },
    { name: "Things To Do", quantity: stats ? stats?.things_to_do : "-", route: "/data/things/todo", key: _TYPES_.THINGSTODO },
    { name: "Tips And Advice", quantity: stats ? stats?.tips_and_advice : "-", route: "/data/tips/advice", key: _TYPES_.TIPSANDADVICE },
    { name: "Ministries", quantity: stats ? stats?.ministry : "-", route: "/data/ministry", key: _TYPES_.MINISTRY },
    { name: "Movies", quantity: stats ? stats?.movie : "-", route: "/data/movie", key: _TYPES_.MOVIE },
    { name: "Getting Around", quantity: stats ? stats?.getting_around : "-", route: "/data/get/around", key: _TYPES_.GETTINGAROUND },
    { name: "Products", quantity: stats ? stats?.product : "-", route: "/data/product", key: _TYPES_.PRODUCT },
  ];

  // Icon mapping by name (prevents index mismatches)
  const ICONS = {
    "regions": <MdOutlineMapsHomeWork />,
    "countries": <MdOutlineMapsHomeWork />,
    "first level": <MdOutlineMapsHomeWork />,
    "second level": <MdOutlineMapsHomeWork />,
    "third level": <MdOutlineMapsHomeWork />,
    "fourth level": <MdOutlineMapsHomeWork />,

    "events": <VscFileSubmodule />,
    "attractions": <GrAttraction />,
    "restaurants": <GrRestaurant />,
    "best of africa": <MdOutlineHotelClass />,
    "music": <MdMusicNote />,
    "news": <BsBook />,
    "safaris": <MdOutlineMuseum />,
    "tour packages": <GrAttraction />,
    "cinema": <BiCameraMovie />,
    "museums": <MdOutlineMuseum />,
    "night life": <MdOutlineNightlight />,
    "hotels": <SiHotelsdotcom />,
    "classes": <MdOutlineHotelClass />,
    "shopping": <AiOutlineShopping />,
    "food": <MdOutlineFoodBank />,
    "books": <BsBook />,
    "neighborhoods": <BsPeople />,
    "arts": <MdOutlineFormatPaint />,
    "dance": <GiBallerinaShoes />,
    "theaters": <GiTheater />,
    "city guides": <GrAttraction />,
    "parties": <BsBook />,
    "things to do": <HiOutlineDocument />,
    "tips and advice": <BsBook />,
    "ministries": <MdOutlineMapsHomeWork />,
    "movies": <GiTheater />,
    "getting around": <MdOutlineMapsHomeWork />,
    "products": <MdShop />,
  };

  // Grouping
  const geographySet = new Set([
    "regions",
    "countries",
    "first level",
    "second level",
    "third level",
    "fourth level",
  ]);

  const normalized = (s = "") => String(s).toLowerCase();
  const byQuery = (item) => !query || normalized(item.name).includes(normalized(query));
  const byCategory = (item) => {
    const isGeo = geographySet.has(normalized(item.name));
    if (category === "All") return true;
    if (category === "Geography") return isGeo;
    return !isGeo;
  };

  const filtered = List.filter((i) => byQuery(i) && byCategory(i));
  const geoItems = filtered.filter((i) => geographySet.has(normalized(i.name)));
  const contentItems = filtered.filter((i) => !geographySet.has(normalized(i.name)));

  // Quick summary (UI only)
  const summary = [
    { label: "Regions", value: stats?.continent_region ?? "-", key: "regions" },
    { label: "Countries", value: stats?.country ?? "-", key: "countries" },
    {
      label: "Content Types",
      value: ([
        "event", "attraction", "restaurant", "best_of_africa", "music", "news", "safari",
        "tour_package", "cinema", "museum", "nightlife", "hotel", "class", "shopping", "food",
        "book", "neighborhood", "art", "movie", "dance", "theater", "city_guide", "party",
        "things_to_do", "tips_and_advice", "ministry", "getting_around", "product"
      ]).length,
      key: "types"
    },
  ];

  return (
    <div className="overflow-y-auto p-3 lg:p-4 h-full rounded-b-xl bg-gray-50">
      {/* Header / Filters */}
      <div className="mx-auto mb-4 max-w-7xl">
        <div className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            <div>
              <h2 className="text-sm font-semibold tracking-tight text-gray-900">
                DoSee Africa — Content Directory
              </h2>
              <p className="mt-1 text-[11px] text-gray-600">
                Manage geographic structure and all rich content types. Use search and the chips to filter fast.
              </p>
            </div>

            <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
              <div className="relative">
                <input
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder="Search (e.g., 'hotel', 'news')"
                  className="w-full rounded-lg border border-gray-200 bg-white p-2.5 pr-8 text-xs focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-200"
                />
                {query ? (
                  <button
                    type="button"
                    aria-label="Clear"
                    onClick={() => setQuery("")}
                    className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                  >
                    ×
                  </button>
                ) : null}
              </div>

              <div className="flex gap-1">
                {["All", "Geography", "Content"].map((c) => (
                  <button
                    key={c}
                    onClick={() => setCategory(c)}
                    className={`rounded-full px-3 py-1 text-[11px] font-semibold transition ${category === c
                        ? "bg-gray-900 text-white"
                        : "border border-gray-200 bg-white text-gray-700 hover:bg-gray-50"
                      }`}
                  >
                    {c}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Quick Summary */}
          <div className="mt-4 grid grid-cols-3 gap-2">
            {summary.map((s, i) => (
              <div key={i} className="rounded-xl border border-gray-100 bg-gray-50 p-3 text-center">
                <p className="text-[11px] font-medium text-gray-600">{s.label}</p>
                <p className="text-base font-semibold text-gray-900">{s.value}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Empty state */}
      {filtered.length === 0 ? (
        <div className="mx-auto max-w-7xl">
          <div className="rounded-xl border border-dashed border-gray-200 bg-white p-8 text-center text-xs text-gray-600 shadow-sm">
            No matches found. Try a different filter or keyword.
          </div>
        </div>
      ) : null}

      {/* Geography group */}
      {geoItems.length > 0 && (
        <div className="mx-auto max-w-7xl">
          <h3 className="mb-2 px-1 text-[11px] font-semibold uppercase tracking-wide text-gray-600">
            Geography
          </h3>
          <div className="grid grid-cols-2 gap-4 md:grid-cols-4 xl:grid-cols-8 items-start selection:text-white selection:bg-blue-900 mb-5">
            {geoItems.map((card, index) => {
              const icon = ICONS[normalized(card.name)] || <MdOutlineMapsHomeWork />;
              return (
                <Link
                  to={card.route}
                  key={`${card.name}-${index}`}
                  onClick={() => {
                    if (
                      !["regions", "countries", "First Level", "Second Level", "Third Level", "Fourth Level"].includes(card.name)
                    ) {
                      setSingleAdmin({
                        ids: [sysAdmin?.admin_id],
                        type: getType({ field: card?.key }),
                        route: "/levels/dashboard",
                      });
                      addOneLevel({
                        id: 0,
                        name: `${sysAdmin?.first_name} ${sysAdmin?.last_name}`,
                        route: "/levels/first",
                        level: "",
                        country_id: 0,
                        data: {
                          data: {
                            name: "",
                            country_id: 0,
                            first_level_id: 0,
                            second_level_id: 0,
                            third_level_id: 0,
                            fourth_level_id: 0,
                            level: "",
                          },
                        },
                      });
                      pushLevel({
                        level: { id: 0, name: "", level: "All", route: "/levels/first", data: null },
                      });
                    }
                  }}
                >
                  <div className="transition-transform duration-150 ease-out hover:-translate-y-0.5">
                    <Card card={{ name: card.name, quantity: card.quantity, icon }} />
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      )}

      {/* Content group */}
      {contentItems.length > 0 && (
        <div className="mx-auto max-w-7xl">
          <h3 className="mb-2 px-1 text-[11px] font-semibold uppercase tracking-wide text-gray-600">
            Content Types
          </h3>
          <div className="grid grid-cols-2 gap-4 md:grid-cols-4 xl:grid-cols-8 items-start selection:text-white selection:bg-blue-900 mb-5">
            {contentItems.map((card, index) => {
              const icon = ICONS[normalized(card.name)] || <MdOutlineMapsHomeWork />;
              return (
                <Link
                  to={card.route}
                  key={`${card.name}-${index}`}
                  onClick={() => {
                    if (
                      !["regions", "countries", "First Level", "Second Level", "Third Level", "Fourth Level"].includes(card.name)
                    ) {
                      setSingleAdmin({
                        ids: [sysAdmin?.admin_id],
                        type: getType({ field: card?.key }),
                        route: "/levels/dashboard",
                      });
                      addOneLevel({
                        id: 0,
                        name: `${sysAdmin?.first_name} ${sysAdmin?.last_name}`,
                        route: "/levels/first",
                        level: "",
                        country_id: 0,
                        data: {
                          data: {
                            name: "",
                            country_id: 0,
                            first_level_id: 0,
                            second_level_id: 0,
                            third_level_id: 0,
                            fourth_level_id: 0,
                            level: "",
                          },
                        },
                      });
                      pushLevel({
                        level: { id: 0, name: "", level: "All", route: "/levels/first", data: null },
                      });
                    }
                  }}
                >
                  <div className="transition-transform duration-150 ease-out hover:-translate-y-0.5">
                    <Card card={{ name: card.name, quantity: card.quantity, icon }} />
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      )}

      {/* Table (unchanged) */}
      <TableStatistics />
    </div>
  );
};

export default Content;
